<app-button [size]="size()" [label]="buttonLabel()" (click)="clickButton()" />
@if (showDialog()) {
  <app-dialog [dimensions]="dimensions()" [canScroll]="true" (onClose)="showDialog.set(false)" [header]="label()">
    <table class="table table-hover mt-1">
      <thead>
        <tr>
          @if (hasRAG()) {
            <th></th>
          }
          <th>{{ heading() }}</th>
        </tr>
      </thead>
      <tbody>
        @for (item of list(); track item.id) {
          <tr (click)="clickRow(item)">
            @if (hasRAG()) {
              <td class="rag rag-{{ item.rag }}"></td>
            }
            <td>{{ item.label ?? item.title }}</td>
          </tr>
        }
      </tbody>
    </table>
  </app-dialog>
}
